import { z } from 'zod';
/** GET /health - liveness. Always 200 while the process is up (Docs/API.md §2.1). */
export const HealthResponseSchema = z.object({
    status: z.literal('ok'),
});
/**
 * One dependency check in GET /ready.
 * `skipped` is used while a dependency is not yet wired (see M1.1 for `db`,
 * M1.11 for `queue`); it never reports a dependency as healthy that was not checked.
 */
export const ReadinessCheckSchema = z.enum(['ok', 'failed', 'skipped']);
/** GET /ready - 200 only when every wired dependency answers; 503 NOT_READY otherwise. */
export const ReadyResponseSchema = z.object({
    status: z.enum(['ready', 'not_ready']),
    checks: z.record(z.string(), ReadinessCheckSchema),
});
/** GET /version - build identity, shown in every app footer (ARCHITECTURE.md §18). */
export const VersionResponseSchema = z.object({
    version: z.string(),
    commit: z.string(),
    builtAt: z.string(),
});
//# sourceMappingURL=operational.js.map